import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import CloseButtonContainer from '../containers/CloseButtonContainer';

import styles from 'presentation/components/styles/Header.css';
let cx = classnames.bind(styles);

export default function Header(props) {
  const headerPropTypes = {
    isOnboarding: PropTypes.bool,
    title: PropTypes.string.isRequired,
  };
  PropTypes.checkPropTypes(headerPropTypes, props, 'prop', 'Header');

  let classes = cx('header', {
    header_onboarding: props.isOnboarding,
  });

  return (
    <div className={classes} id="gladlyChatDragHandle">
      <div className={styles.header_spacer} />
      <div className={styles.header_title}>{props.title}</div>
      <CloseButtonContainer
        className={styles.header_buttonMinimize}
        data-aid="gladlyChatCloseButton"
        isOnboarding={props.isOnboarding}
      />
    </div>
  );
}
